import React, {FC, useState} from 'react';
import {useEvents} from 'hooks/useEvents';
import {useToggle} from 'hooks/useToggle';
import {LngLatBounds} from 'mapbox-gl';
import BookingMap from 'pages/booking/components/Map';
import {useParseCoords} from 'pages/booking/components/Map/useParseCoords';
import {LocationProvider, useCreateLocation} from 'pages/booking/components/useLocation';

import {EventsList} from './EventsList';

import * as styles from './styles.module.scss';

type BookingProps = {
	region?: string
	coords?: string
	zoom?: string
}

export const BookingWidget: FC<BookingProps> = ({region, coords, zoom}) => {
	const {open: show, toggle} = useToggle(false);
	const [bounds, setBounds] = useState<LngLatBounds>();

	const location = useCreateLocation();
	const init = useParseCoords(coords, zoom);
	const {state} = useEvents({
		region: region || location.configs.region?.key,
	});

	return (
		<div className={styles.wrapper}>
			<LocationProvider location={location}>
				<BookingMap
					className={styles.map}
					region={state.vars.region}
					init={init}
					locations={state.locations}
					mapProps={{
						onLoad: (e) => {
							setBounds(e.target.getBounds());
						},
						onMoveEnd: (e) => {;
							setBounds(e.target.getBounds());
						},
					}}
				/>
				<EventsList
					events={state}
					bounds={bounds}
					show={show}
				/>
				<div className={styles.text}>
					Locations update to match map view
				</div>
			</LocationProvider>
			<div onClick={toggle} className={styles.toggle}>
				{show ? 'View map' : 'View list'}
			</div>
		</div>
	);
};
